<div class="w-100 d-flex flex-column surface-elevated">
  <ngx-app-bar
    class="w-100"
    [title]="'فروش'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  @if (isLoading) {
    <app-spinner></app-spinner>
  } @else {
    <div class="w-100 mt-plus d-flex align-items-center justify-content-center px-plus sell-price-unit">
      <app-price-unit
        class="w-100"
        sectionType="SELL"
        [data]="assetData"
        [unitCount]="availableUnits"
      ></app-price-unit>
    </div>
    <div class="w-100 d-flex mt-big px-plus flex-column pb-plus sell-content">
      <span class="b-2 text-onback-high">{{
          assetData?.investmentType === 'ETF' || assetData?.type === 'Stock'
            ? 'تعداد واحدهای مورد نظر برای فروش را وارد کنید.'
            : 'تعداد واحدهای مورد نظر برای ابطال را وارد کنید.'
        }}</span>
      <div
        [formGroup]="form"
        class="w-100 mt-medium d-flex flex-column sell-price-form"
      >
        <ui-form-field
          label="تعداد واحد"
          [isNumericKeyboard]="true"
          formControlName="count"
          [hasCleaner]="true"
          type="amount"
          (ngModelChange)="countChanged($event)"
          [error]="form.controls['count'].errors"
          [errorMessage]="isValid() ? '' : ' '"
          [showError]="showError"
          [maxSize]="10"
          [readonly]="!this.availableUnits"
        ></ui-form-field>
        @if (tomanValue && showError === 'hidden') {
          <div class="d-flex mt-medium radius-medium surface-back gap-tiny justify-content-center py-small px-medium">
            <span>{{ tomanValue }}</span>
            <span>تومان</span>
          </div>
        }
        @if (showError === 'show' && !isValid()) {
          <div class="d-flex text-onback-error sell-price-error">
            @if (!this.availableUnits) {
              <span class="text-onback-brand"> شما موجودی قابل برداشت ندارید </span>
            } @else {
              <span> موجودی قابل برداشت شما {{ availableUnits }} واحد است. </span>
            }
          </div>
        }
      </div>
      <div class="w-100 d-flex align-items-end mt-mesium">
        <ngx-callout
          class="w-100"
          [title]="''"
          [showTitleBlink]="false"
          [mode]="'multiple'"
          [messages]="[
            {
              text:'نهایی شدن فروش در این صندوق ها بین ۱ الی ۲ روز کاری زمان می‌برد.',
              showDot:true,
              showLine:true
            },
            {
              text:'می توانید مبلغ حاصل از فروش را از کیف پول خود برداشت کنید.',
              showDot:true,
              showLine:true
            },
          ]"
        />
      </div>
      @if (showAgreementCheckbox) {
        <div class="d-flex mt-plus align-items-center gap-small">
          <ngx-checkbox
            (checkedChange)="onToggleAgreement($event)"
            [(checked)]="agreementChecked"
            [disabled]="!this.availableUnits"
          >
          </ngx-checkbox>
          <div class="d-flex gap-tiny">
            <span>شرایط</span>
            <span
              (click)="agreementView(pdfType.PROSPECTUS)"
              class="text-onback-brand cursor-pointer"
            >امیدنامه</span
            >
            @if (assetData?.investmentType === 'ETF') {
              ،
            } @else {
              <span>و</span>
            }
            <span
              (click)="agreementView(pdfType.STATUTE)"
              class="text-onback-brand cursor-pointer"
            >اساسنامه</span
            >
            @if (assetData?.investmentType === 'ETF') {
              <span>و</span>
              <span
                (click)="agreementView(pdfType.REGULATIONS)"
                class="statute-text"
              >
                قوانین و مقررات
              </span>
            }
            <span>را می‌پذیرم.</span>
          </div>
        </div>
      }
      <div class="w-100 mt-medium">
        <ngx-button
          [fullWidth]="true"
          (clickHandler)="onShowDetail()"
          [disabled]="!this.availableUnits || (showError === 'show' && showAgreementCheckbox) || !agreementChecked"
        >
          فروش
        </ngx-button>
      </div>
    </div>
  }
</div>
